import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Category } from 'src/app/cards/category/category.model';
import { CategoryService } from 'src/app/cards/category/category.service';
import { Product } from 'src/app/cards/product/product.model';
import { ProductService } from 'src/app/cards/product/product.service';
import { SubCategory } from 'src/app/cards/subcategory/subCategory.model';
import { SubcategoryService } from 'src/app/cards/subcategory/subcategory.service';
import { Globle } from 'src/assets/globle';
import { OrderByProduct } from '../orderbyproduct.model';
import { Profits } from '../profit.model';
import { ReportsService } from '../reports.service';

@Component({
  selector: 'app-profits',
  templateUrl: './profits.component.html',
  styleUrls: ['./profits.component.css']
})
export class ProfitsComponent implements OnInit {

  reports: OrderByProduct[] = [];
  profits: Profits = {} as Profits;
  subCategories: SubCategory[] = [];
  category: Category[] = [];
  products: Product[] = [];
  displayedColumns: string[] = ['date', 'quantity', "total"];
  dataSource!: MatTableDataSource<OrderByProduct>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;
  spinnerOverlay = false;
  selectedCategory!: number;
  selectedSubCategory!: number;
  selectedProduct!: number;
  lang = 'en';
  reportObj: OrderByProduct = {} as OrderByProduct;
  directCharged = false;
  basicPrice = 0.0;
  pageSize = 100;

  constructor(private service: ReportsService,
    private categoryService: CategoryService,
    private subCategoryService: SubcategoryService,
    private productService: ProductService,
    private translate: TranslateService,
    private globle: Globle) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getCategory();
  }

  getCategory() {
    this.categoryService.getAll(1, this.directCharged).subscribe(data => {
      this.category = data;
    }, error => {
      console.log(error)
    })
  }

  getSubCategory() {
    this.subCategoryService.getAll(this.selectedCategory, 1).subscribe(data => {
      this.subCategories = data
    }, error => {
      console.log(error)
    });
  }

  getProduct() {
    this.productService.getAll(this.selectedSubCategory, 1).subscribe(data => {
      this.products = data
    }, error => {
      console.log(error)
    })
  }

  getProfits() {

    this.spinnerOverlay = true;
    this.service.getProfits(this.selectedProduct, this.fromDate.nativeElement.value,
      this.toDate.nativeElement.value, this.basicPrice).subscribe(data => {
        this.profits = data;
        this.dataSource = new MatTableDataSource(this.profits.ordersByProducts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      }, error => {
        console.log(error);
      })
  }

  onApply() {
    this.getProfits();
  }

  // getTotalCost() {
  //   this.reports = this.profits.ordersByProducts;

  //   if (this.profits != undefined)
  //     return this.reports.map(t => t.total).reduce((acc, value) => acc + value, 0).toFixed(3);
  //   else
  //     return 0;
  // }

  onCategoryChange() {
    this.getSubCategory();
  }

  onsubCategoryChange() {
    this.getProduct();
  }

  onChangeProduct() {
    this.productService.getById(this.selectedProduct).subscribe(data => {
      this.basicPrice = data["costPrice"];
    },
      error => {
        console.log(error)
      })
  }

}
